module.exports = __webpack_public_path__ + "img/P150T_weapon_95.f9890009.png";